<template>
 <GestionFiltros/>
</template>
<script setup>
import GestionFiltros from "@/views/admin/filtros/components/GestionFiltros.vue";
</script>
